module.exports = __webpack_public_path__ + "img/guide-user-to-mobile.a4a0317.svg";